import React from 'react';
import { styled } from '@mui/material/styles';
import { QcIssueAuthor } from '../../../interfaces/qcIssue.interface';
import { ACCENT_BLUE_DARK } from './qcTheme';

// Anonymous TPN admins show the brand shield on avatar blue; assessors and First Pass keep initials on the light tint.

const Circle = styled('span', {
  shouldForwardProp: prop => !['size', 'brand'].includes(prop as string),
})<{ size: number; brand: boolean }>(({ size, brand }) => ({
  width: `${size}px`,
  height: `${size}px`,
  borderRadius: '50%',
  flex: 'none',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  fontSize: size >= 40 ? '0.85rem' : '0.72rem',
  fontWeight: 700,
  background: brand ? '#3868B9' : 'rgba(25,118,210,0.14)',
  color: brand ? '#fff' : ACCENT_BLUE_DARK,
}));

const BadgeImage = styled('img')({
  width: '70%',
  height: '70%',
  objectFit: 'contain',
});

export function isAnonymousAdmin(author: QcIssueAuthor): boolean {
  return author.role === 'tpn_admin' && author.name !== 'First Pass';
}

export interface QcAuthorAvatarProps {
  author: QcIssueAuthor;
  size: number;
}

export default function QcAuthorAvatar({ author, size }: QcAuthorAvatarProps): JSX.Element {
  return (
    <Circle size={size} brand={isAnonymousAdmin(author)}>
      {isAnonymousAdmin(author)
        ? <BadgeImage src={`${process.env.PUBLIC_URL}/assets/TPN-Logo-Shield.png`} alt='TPN Admin' />
        : author.initials}
    </Circle>
  );
}
